import { initialiseSnowplow, initialSentrySetup } from '@/utils/analytics';
import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { useAtomValue } from 'jotai';
import { loadableUserDetailsAtom } from '@/atoms/queries/user';

export const useTracking = () => {
  const { user } = useKitbagAuth();

  if (user?.sub) {
    initialSentrySetup(user.sub, user.email);
  }

  const userDetails = useAtomValue(loadableUserDetailsAtom);

  if (userDetails?.state !== 'hasData' || !user?.sub) return;

  initialiseSnowplow(user.sub, userDetails.data.data.entity.entity_id, userDetails.data.data.entity.name);
};
